import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";

export default function DivisionWisePOGRNSummaryGrid({ data = [] }) {
  const [isMobile] = useState(window.innerWidth <= 768);

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "DivisionPOGRN_GridID_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <div
      className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
      style={{
        position: "relative",
        marginTop: "10px",
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        padding: "6px",
        marginBottom: "20px",
      }}
    >
      <Row>
        <Col>
          <GridComponent
            ref={(g) => (gridInstance = g)}
            id="DivisionPOGRN_GridID"
            dataSource={data}
            allowPaging={true}
            allowSorting={true}
            allowFiltering={true}
            filterSettings={{ type: "Excel" }}
            toolbar={["ExcelExport", "Search"]}
            allowExcelExport={true}
            toolbarClick={toolbarClick}
            enableAdaptiveUI={isMobile}
            rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
            gridLines="Both"
            height={"350px"}
            pageSettings={{
              pageSizes: [10, 20, 30, 40, 50, "All"],
              pageCount: 10,
            }}
            dataBound={() => {
              if (gridInstance) gridInstance.autoFitColumns();
            }}
            rowHeight={isMobile ? "" : 34}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="serialNo"
                headerText="S No"
                width="90"
                textAlign="Center"
                isPrimaryKey={true}
                allowFiltering={false}
              />
              <ColumnDirective
                field="Division"
                headerText="Division"
                width="160"
                textAlign="Left"
              />
              <ColumnDirective
                field="DivisionName"
                headerText="Division Name"
                width="250"
                textAlign="Left"
              />
              <ColumnDirective
                field="TotalPOValue"
                headerText="Total PO Value (In Lacs)"
                width="240"
                textAlign="Right"
                format="N2"
              />
              <ColumnDirective
                field="GRNValue"
                headerText="GRN Value (In Lacs)"
                width="220"
                textAlign="Right"
                format="N2"
              />
              <ColumnDirective
                field="GRNPendingValue"
                headerText="GRN Pending Value"
                width="220"
                textAlign="Right"
                format="N2"
              />
              <ColumnDirective
                field="VendorDeliveredCount"
                headerText="Vendor Delivered Count"
                width="230"
                textAlign="Center"
              />
              <ColumnDirective
                field="VendorGRNPendingCount"
                headerText="Vendor GRN Pending Count"
                width="250"
                textAlign="Center"
              />
              <ColumnDirective
                field="ItemReceivedCount"
                headerText="Item Received Count"
                width="220"
                textAlign="Center"
              />
            </ColumnsDirective>
            <Inject
              services={[Page, Filter, Toolbar, ExcelExport, Sort, Group, Resize, Freeze]}
            />
          </GridComponent>
        </Col>
      </Row>
    </div>
  );
}
